import React from 'react';
import Contact from '../component/contact/Contact';
import MyServices from '../component/contact/MyServices';

function ContactPage() {
  return (
    <main>
      <MyServices />
      <Contact />
    </main>
  );
}

export default ContactPage;
